<template>
  <div>
    <list
      row-key="PurchaseArrivalId"
      ref="list"
      unit="应付总账"
      :page="page"
      :pageSizes="[10, 20, 30, 40, 100, 1000]"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :delete-func="api.delete"
      :get-data-func="api.DetailsList"
      show-summary  
      :summary-method="getSummaries"
      isSumData
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="单据编号">
          <el-input size="mini" clearable v-model="params.DocNo" placeholder="请输入单据编号" />
        </el-form-item>
        <el-form-item label="商品名称">
         <el-input size="mini" clearable v-model="params.GoodsName" placeholder="请输入商品名称" />
        </el-form-item>
        <el-form-item label="供应商">
           <supplier  @restaurants='setSupplier' :state='params.SupplierName'/>
        </el-form-item>
        <!-- <el-form-item label="商品分类" prop="ClassName">
           <el-input v-model="params.ClassName" @focus="openClass" readonly></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="业务员" prop="ClerkName">
            <el-input v-model="params.ClerkName" @focus="addEmp" readonly></el-input>
        </el-form-item> -->
        <template>
          <el-form-item label="单据日期">
            <el-date-picker
              v-model="params.DocDateStart"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择开始时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="截止日期">
            <el-date-picker
              v-model="params.DocDateEnd"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择结束时间"
            ></el-date-picker>
          </el-form-item>

        </template>

      </template>
      <template slot="table">
      <el-table-column prop="DocNo" label="单据编号"/>
      <el-table-column prop="DocDate" label="单据日期" />
      <el-table-column label="供应商" prop="SupplierName"/>
      <el-table-column label="商品编码" prop="GoodsCode"/>
      <el-table-column label="商品名称" prop="GoodsName"/>
      <!-- <el-table-column label="商品分类" prop="ClassName"/> -->
      <!-- <el-table-column label="业务员" prop="ClerkName"/> -->
      <el-table-column prop="Model" label="规格型号" />
      <el-table-column prop="UnitName" label="单位" />
      <el-table-column prop="Quantity" label="数量"/>
      <el-table-column prop="Price" label="单价">
        <template slot-scope="{ row }">
            {{$commonJs.toThousands(row.Price)}}
            </template>
      </el-table-column>
      <el-table-column prop="Amount" label="金额">
        <!-- <template slot-scope="{ row }">
            {{$commonJs.toThousands(row.Amount)}}
            </template> -->
      </el-table-column>
      <el-table-column prop="Remark" label="备注"/>
      <!-- <el-table-column prop="ExistQuantity" label="现存量" />
      <el-table-column prop="AvailableQuantity" label="可用量 " /> -->
      <el-table-column prop="Offer" label="报价">
        <template slot-scope="{ row }">
            {{$commonJs.toThousands(row.Offer)}}
            </template>
      </el-table-column>
      <el-table-column prop="Discount" label="折扣%"/>
      <el-table-column prop="NoTaxPrice" label="无税单价">
        <template slot-scope="{ row }">
            {{$commonJs.toThousands(row.NoTaxPrice)}}
            </template>
      </el-table-column>
     
      <el-table-column prop="TaxRate" label="税率/%"/>
      <el-table-column prop="TaxAmount" label="税额">
        <template slot-scope="{ row }">
            {{$commonJs.toThousands(row.TaxAmount)}}
            </template>
      </el-table-column>
      
      <el-table-column prop="NoTaxAmount" label="不含税金额" width="100">
        <template slot-scope="{ row }">
            {{$commonJs.toThousands(row.NoTaxAmount)}}
            </template>
      </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <class-dialog ref="classDialog" selectable multiple  @select="setClass" title="商品分类"/>
     <supplier-dialog ref="supplierDialog" in-dialog selectable @select="setSupplier" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import empDialog from "@/components/sales/business/empDialog";
import classDialog from "@/components/basicinfo/goods/archives/goodsTree/listDialog";
import supplierDialog from "@/components/purchase/supplier/archives/listDialog";
import supplier from "@/components/common/supplier/supplier";
export default {
  mixins: [listMixin],
  components: { list,empDialog,classDialog,supplierDialog,supplier },
  data() {
    return {
      api: require("@/api/purchase/pudocgoods").default,
      exp_api: require("@/api/purchase/return").default,
      dpapi: require("@/api/ba/tradeUnit").default,
      supplierList:[],
      params: {
         GoodsName:"",
         DocNo:"",
         DocDateStart: this.$commonJs.getDayOffset(-30),
         DocDateEnd: this.$commonJs.getDayOffset(0),
         IdChain:"",
         ClassName:"",
         ClerkId:"",
         ClerkName:"",
         SupplierId:"",
         SupplierName:"",
      },
      isMB: this.$store.state.isMB,
    };
  },
   mounted() {
       this.dpapi.list({}).then(res => {
        let list=[]
        res.Data.forEach(e => {
          list.push( { "value": e.SupplierName, "Id": e.SupplierId },)
        });
        this.supplierList=list
      })
  },
  computed: {
    date() {
      return [this.params.MonthStart, this.params.MonthEnd];
    },
    sDate() {
      return this.$dayjs().endOf("month").format("YYYY-MM-DD");
    },
    eDate() {
      return this.$dayjs()
        .subtract(3, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
    },
  },
  methods: {
      setSupplier(data) {
        console.log(data)
        this.params.SupplierId = data.TradeUnitId;
        this.params.SupplierName = data.TradeUnitName;
      },
      handleSelect(item) {
        
        this.params.SupplierName=item.value
        this.params.SupplierId=item.Id
      },
      querySearchAsync(queryString, cb) {
        var supplierList = this.supplierList;
        var results = queryString ? supplierList.filter(this.createStateFilter(queryString)) : supplierList;
        cb(results);
      },
      createStateFilter(queryString) {
        return (state) => {
          if(state.value){
          return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
          }
        };
      },
    onExport() {
      this.exp_api.export(this.params);
    },
    
    getSummaries(param) {
      const { columns, data } = param;
      const fieldsToSum = ['Quantity', 'Amount', 'TaxAmount', 'GrossProfit'];
      const sums = [];
      sums[0] = "当页合计";
      columns.forEach((column, index) => {
        if (fieldsToSum.includes(column.property)) {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            const sum = values.reduce((prev, curr) => {
              const value = Number(curr);
              return !isNaN(value) ? prev + value : prev;
            }, 0);
            if (column.property === 'Quantity') {
              sums[index] = sum.toLocaleString(undefined, { minimumFractionDigits: 4, maximumFractionDigits: 4 });
            } else {
              sums[index] = sum.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
          } else {
            sums[index] = "0.00";
          }
        } else {
          if (sums[index] === undefined) {
            sums[index] = ""; 
          }
        }
      });
      return sums;
    },
    setEmp(e) {
      this.data.ClerkId = e.EmpId
      this.data.ClerkName = e.EmpName
    },
    setClass(data) {
      
      this.params.IdChain = data.IdChain;
      this.params.ClassName = data.ClassName;
    },
    openClass() {
      this.$refs.classDialog.open().then((that) => {
        that.getData({ Status: 1, ClassType: 6 });
      });
    },

    addEmp() {
      // let ids = this.PriAdjustEmpList.map((x) => x.EmpId);
      this.$refs.empDialog.open().then((that) => {
        that.getData({ Status: 1 });
      });
    },
    openSupplierDialog() {
      this.$refs.supplierDialog.open().then((that) => {
        that.getData();
        that.getTree();
      });
    },
    dateChange(val) {
      this.params.DocDateStart = val.Start;
      this.params.DocDateEnd = val.End;
    },
    monthChange(val) {
      this.params.MonthStart = val.Start;
      this.params.MonthEnd = val.End;
    },
    onClick(row) {
      
      this.$refs.listDialog.open().then((that) => {
        var params = {
          TradeUnitId: row.TradeUnitId,
          TradeUnitName: row.TradeUnitName,
          DocDateStart: this.params.DocDateStart,
          DocDateEnd: this.params.DocDateEnd,
        };
        that.query(params);
      });
    },
    cycleChange(t) {
      var today = this.$commonJs.getToday();
      var start = "";
      var end = "";
      switch (t) {
        case "今天":
          start = today;
          end = today;
          break;
        case "昨天":
          start = this.$dayjs().subtract(1, "day").format("YYYY-MM-DD");
          end = start;
          break;
        case "近3天":
          start = this.$dayjs().subtract(2, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近7天":
          start = this.$dayjs().subtract(6, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近14天":
          start = this.$dayjs().subtract(13, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "本周":
          start = this.$dayjs().startOf("week").format("YYYY-MM-DD");
          end = today;
          break;
        case "上周":
          var week = this.$dayjs().subtract(1, "week");
          start = week.startOf("week").format("YYYY-MM-DD");
          end = week.endOf("week").format("YYYY-MM-DD");
          break;
        case "本月":
          start = this.$dayjs().startOf("month").format("YYYY-MM-DD");
          end = today;
          break;
        case "上月":
          var month = this.$dayjs().subtract(1, "month");
          start = month.startOf("month").format("YYYY-MM-DD");
          end = month.endOf("month").format("YYYY-MM-DD");
          break;
        case "本季":
          start = this.$dayjs().startOf("quarter").format("YYYY-MM-DD");
          end = today;
          break;
        case "上季":
          var quarter = this.$dayjs().subtract(1, "quarter");
          start = quarter.startOf("quarter").format("YYYY-MM-DD");
          end = quarter.endOf("quarter").format("YYYY-MM-DD");
          break;
        case "本年":
          start = this.$dayjs().startOf("year").format("YYYY-MM-DD");
          end = today;
          break;
        case "上年":
          var year = this.$dayjs().subtract(1, "year");
          start = year.startOf("year").format("YYYY-MM-DD");
          end = year.endOf("year").format("YYYY-MM-DD");
          break;
      }
      this.params.DocDateStart = start;
      this.params.DocDateEnd = end;
      this.query();
    },
  },
};
</script>